import { type MouseEvent } from 'react';
import {
    type TreeSelectSelectionMode,
    type TreeSelectValue,
} from '../models/tree-select-checkbox-selection-behavior';
import {
    type TreeSelectChangeEvent,
    type TreeSelectProps,
    type TreeSelectSelectedValueLayout,
} from '../models/tree-select.types';

export function shouldUseExternalSelectedValueLayout(
    selectionMode: TreeSelectSelectionMode | undefined,
    selectedValueLayout: TreeSelectSelectedValueLayout | undefined,
): boolean {
    if (selectedValueLayout === 'external') {
        return true;
    }

    if (selectedValueLayout === 'inline') {
        return false;
    }

    return selectionMode === 'multiple' || selectionMode === 'checkbox';
}

export function createChangeEvent(
    event: MouseEvent<HTMLButtonElement>,
    props: TreeSelectProps,
    value: TreeSelectValue,
): TreeSelectChangeEvent {
    return {
        originalEvent: event,
        value,
        stopPropagation: () => {
            event?.stopPropagation();
        },
        preventDefault: () => {
            event?.preventDefault();
        },
        target: {
            name: props.name ?? '',
            id: props.id ?? '',
            value,
        },
    };
}
